import { PermissoesService } from './../../../service/usuario/permissoes.service';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TipoEnderecoModel } from 'app/model/endereco/tipoendereco.model';
import { TipoenderecoService } from 'app/service/endereco/tipoendereco.service';
import * as CryptoJS from 'crypto-js';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';

@Component({
  selector: 'app-tipoendereco',
  templateUrl: './tipoendereco.component.html',
  styleUrls: ['./tipoendereco.component.scss']
})
export class TipoenderecoComponent implements OnInit {

  public submit = false;
  public loading = true;
  public page: ResponsePageable;

  tipoEndereco = {} as TipoEnderecoModel;
  tipoEnderecos: TipoEnderecoModel[];
  horizontalPosition: MatSnackBarHorizontalPosition = 'right';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  public pageAtual = 0;

  public edited = false;
  public editado = false;
  public errorAlert = false;
  public successDelete = false;
  public arrayString: string;
  public creatorTipoEndereco = false;
  public editorTipoEndereco = false;
  public listaTipoEndereco = false;
  public deletaTipoEndereco = false;
  public superUser = false;

  @ViewChild('cardEdit') targetEl: ElementRef;
  @ViewChild('tipoEnderecoInput') tipoEnderecoInput: ElementRef;

  constructor(private tipoEnderecoService: TipoenderecoService,
    private _snackBar: MatSnackBar,
    private permissionService: PermissoesService) { }

  ngOnInit() {
    this.listPageTipoEnderecos(0, 10);
    this.getAuthority();
  }

  listarTipoEnderecos() {
    this.tipoEnderecoService.getTipoEnderecos().subscribe(data => {
      this.tipoEnderecos = data.content;
    });
  }

  getAuthority() {
    this.getItemAuthority('authority');
    if (this.arrayString.includes('ADD_EMPRESA')) {
      this.creatorTipoEndereco = true;
    }
    if (this.arrayString.includes('EDIT_EMPRESA')) {
      this.editorTipoEndereco = true;
    }
    if (this.arrayString.includes('LIST_EMPRESA')) {
      this.listaTipoEndereco = true;
    }
    if (this.arrayString.includes('DELETE_EMPRESA')) {
      this.deletaTipoEndereco = true;
    }
    if (this.arrayString.includes('SUPER_USER')) {
      this.superUser = true;
    }
  }

  getItemAuthority(key) {
    const store = sessionStorage.getItem(key);
    if (store) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          store,
          sessionStorage.getItem('ticket-ECM')
        );
        this.arrayString = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.arrayString;
      } catch (e) {
        sessionStorage.clear();
      }
    }

    return null;
  }

  scroll() {
    this.targetEl.nativeElement.scrollIntoView();
  }


  listPageTipoEnderecos(page, size){
    this.tipoEnderecoService.getPageTipoEndereco(page, size).subscribe(res => {
      this.page = res;
      this.tipoEnderecos = this.page.content;
      this.loading = false;
    })
  }

  changePage(event){
    this.listPageTipoEnderecos(event.page, event.size);
    this.pageAtual = event.page;
   }

   onSubmit(){
    this.submit = true;
  }

  postSubmit(){
    this.submit = false;
    this.tipoEnderecoInput.nativeElement.value = '';
    this.tipoEndereco.descricao = null;
  }

  adicionarTipoEndereco(){
    this.tipoEnderecoService.postTipoEndereco(this.tipoEndereco).subscribe(() => {
      if(this.tipoEndereco.id !== undefined) {
        this.tipoEndereco = new TipoEnderecoModel();
        this.listPageTipoEnderecos(this.pageAtual, 10);
        this.openSnackBarSuccess('Tipo de Endereço atualizado com sucesso !');
        this.postSubmit();
      } else {
        this.tipoEndereco = new TipoEnderecoModel();
        this.listPageTipoEnderecos(0, 10);
        this.openSnackBarSuccess('Tipo de Endereço salvo com sucesso !');
        this.postSubmit();
      }
    }, error => {
      this.openSnackBarError('Erro !');
      console.log(error);
    })
  }

  editarTipoEndereco(tipoEndereco: TipoEnderecoModel){
    this.tipoEndereco = { ...tipoEndereco }
  }

  confirmeExclusao(id: number){
    var confirme = confirm("Deseja excluir este tipo de endereço ?")
    if(confirme == true){
      this.apagarTipoEndereco(id);
    } else {
      console.log("Cancelou exclusão!");
    }
  }

  apagarTipoEndereco(id: number){
    this.tipoEnderecoService.deleteTipoEndereco(id).subscribe((tipoEndereco) => {
        this.tipoEndereco = new TipoEnderecoModel();
        this.listPageTipoEnderecos(0, 10);
        this.openSnackBarSuccess('Tipo de Endereço excluído com sucesso !');
    }, error =>{
      this.openSnackBarError('Erro ao excluir! Este tipo de endereço está cadastrado em um endereço.');
      console.log(error);
    });
  }

// SnackBares
openSnackBarSuccess(message: string) {
  this._snackBar.open(message, '', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 4000,
    panelClass: ['success-snackbar']
  });
}

openSnackBarError(message: string) {
  this._snackBar.open(message,'', {
    horizontalPosition: this.horizontalPosition,
    verticalPosition: this.verticalPosition,
    duration: 3000,
    panelClass: ['error-snackbar']
  });
}
}



// WEBPACK FOOTER //
// /app/src/app/components/endereco-components/tipoendereco/tipoendereco.component.ts